/* eslint-disable semi */

/**
 * 少数n桁のフィルター
 * @param {*} value
 */
function _num (value, dig = 0) {
  if (value === null) {
    return null;
  }

  const numValue = value * 1;
  if (isNaN(numValue)) {
    return null;
  }

  let parts = String(numValue).split('.');
  let intVal = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
  let decimals = ((parts.length > 1) ? parts[1] : '') + '00000000';
  if (dig > 0) {
    return intVal + '.' + decimals.substr(0, dig);
  } else {
    return intVal;
  }
}

/**
 * 整数
 * @param {*} value
 */
export function num (value) {
  return _num(value, 0);
};

/**
 * 少数2桁
 * @param {*} value
 */
export function num2 (value) {
  return _num(value, 2);
};



// WEBPACK FOOTER //
// ./src/app/filters/num.js